// extracted by css-extract-rspack-plugin
export default {"Label":"CustomLinkText-module__Label___YAWau"};